
        import '/home/builduser/.yarn/berry/cache/@wix-tour-maker-npm-2.0.166-f17db91957-10.zip/node_modules/@wix/tour-maker/dist/es/src/tourMaker/viewer/react/loader/default/defaultLoader.scss.css.virtualfile';
        module.exports = {"loader":"_loader_1kslv_1"};